import styled from 'styled-components';
import { COLOR_WHITE, COLOR_BLUE_050 } from '@common/assets/styles/colors';
import PAGE_STYLES from '../../helpers/page-styles';

export default styled.div`
  ${PAGE_STYLES};

  h4 {
    margin-bottom: 0;
    font-weight: bold;
    line-height: 20px;
  }

  .custom-input {
    margin-top: 8px;

    input {
      ::placeholder {
        color: ${COLOR_BLUE_050};
      }
    }
  }

  .custom-checkbox-wrapper {
    margin-top: 28px;
  }

  .checkbox-error {
    margin-top: 12px;
  }

  label {
    margin-top: 16px;
  }

  button.send-btn {
    margin-top: 16px;
    margin-bottom: 16px;
  }

  .inputs-wrapper {
    min-height: 340px;
    overflow-y: auto;
  }

  div.error-box {
    display: inline-block;
  }

  svg {
    circle {
      stroke: ${COLOR_WHITE};
    }
  }
`;
